export default __webpack_public_path__ + "static/butik_img7-8721157530f6c745ca007b78a779e560.png";